import * as account from '../actions/account';
import { AccountValidationResult } from '../models/account';

export interface State {
  verifyEmailWorking: boolean;
  verifyEmailSuccess: boolean;
  verifyEmailError: Error;
  accountValidationResult: AccountValidationResult;
}

const initialState: State = {
  verifyEmailWorking: false,
  verifyEmailSuccess: false,
  verifyEmailError: null,
  accountValidationResult: null
}

export function reducer(state = initialState, action: account.Actions): State {
  switch(action.type) {
    case account.USER_VERIFY_EMAIL:
      return {
        ...state,
        verifyEmailWorking: true,
        verifyEmailError: null
      }
    case account.USER_VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        verifyEmailWorking: false,
        verifyEmailSuccess: true,
        accountValidationResult: action.payload,
      }
    case account.USER_VERIFY_EMAIL_FAILED:
      return {
        ...state,
        verifyEmailWorking: false,
        verifyEmailSuccess: false,
        verifyEmailError: action.payload,
      }
    default:
      return state;
  }
}

export const isVerifyEmailWorking = (state: State) => state && state.verifyEmailWorking;
export const isVerifyEmailSuccess = (state: State) => state && state.verifyEmailSuccess;
export const getVerifyEmailError = (state: State) => state && state.verifyEmailError;
export const getAccountValidationResult = (state: State) => state && state.accountValidationResult;
